import { render } from "./ModuleHandoverDetail.vue?vue&type=template&id=33d92d82&scoped=true"
import script from "./ModuleHandoverDetail.vue?vue&type=script&lang=js"
export * from "./ModuleHandoverDetail.vue?vue&type=script&lang=js"

import "./ModuleHandoverDetail.vue?vue&type=style&index=0&id=33d92d82&lang=css"
import "./ModuleHandoverDetail.vue?vue&type=style&index=1&id=33d92d82&scoped=true&lang=css"

import exportComponent from "/var/www/new_dev_tis/frontend/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33d92d82"]])

export default __exports__